import { BaseItemStore } from "../core/BaseStore";
import type UserModel from "./UserModel";

export default class UsersStore extends BaseItemStore<UserModel> {}
